import { useFieldContext } from "@/lib/form-context"
import { Input } from "@/components/ui/input"
import { FormField, FormLabel, FormDescription, FieldInfo } from "@/components/ui/form"

interface TextFieldProps {
  label: string
  required?: boolean
  placeholder?: string
  description?: string
  type?: "text" | "email" | "password" | "url"
}

export function TextField({
  label,
  required,
  placeholder,
  description,
  type = "text",
}: TextFieldProps) {
  const field = useFieldContext<string>()

  return (
    <FormField>
      <FormLabel htmlFor={field.name} required={required}>
        {label}
      </FormLabel>
      <Input
        id={field.name}
        name={field.name}
        type={type}
        value={field.state.value}
        onBlur={field.handleBlur}
        onChange={(e) => field.handleChange(e.target.value)}
        placeholder={placeholder}
      />
      {description && <FormDescription>{description}</FormDescription>}
      <FieldInfo field={field} />
    </FormField>
  )
}
